/**
 * Parses the disabled modules from environment variable.
 *
 * @returns {Set<string>} - A set of disabled module names in lowercase.
 */
const parseDisabledModules = (): Set<string> => {
  const rawDisabledModules = process.env.REACT_APP_DISABLED_MODULES || ''
  if (
    !rawDisabledModules ||
    rawDisabledModules.trim() === '' ||
    rawDisabledModules.trim() === '[]'
  ) {
    return new Set()
  }

  const trimmedInput = rawDisabledModules.trim()

  if (trimmedInput.startsWith('[') && trimmedInput.endsWith(']')) {
    try {
      const parsedArray = JSON.parse(trimmedInput)
      if (Array.isArray(parsedArray)) {
        return new Set(
          parsedArray.map(moduleName => String(moduleName).toLowerCase().trim())
        )
      }
    } catch {
      const bracketContent = trimmedInput.slice(1, -1).trim()
      if (bracketContent) {
        return new Set(
          bracketContent
            .split(',')
            .map(moduleName => moduleName.toLowerCase().trim())
            .filter(moduleName => Boolean(moduleName))
        )
      }
      return new Set()
    }
  }

  return new Set(
    trimmedInput
      .split(',')
      .map(moduleName => moduleName.toLowerCase().trim())
      .filter(moduleName => Boolean(moduleName))
  )
}

/**
 * Set of disabled module names parsed from environment variable.
 */
export const DISABLED_MODULES = parseDisabledModules()

/**
 * Checks if a module is enabled.
 *
 * @param {string} moduleName - The name of the module to check.
 * @returns {boolean} - True if the module is enabled, false otherwise.
 */
export const isModuleEnabled = (moduleName: string): boolean => {
  return !DISABLED_MODULES.has(moduleName.toLowerCase().trim())
}
